import { useState, useEffect } from 'react';
import CouponForm from './components/CouponForm';
import CheckoutForm from './components/CheckoutForm';
import { fetchCountries } from '../services/magento/api';
import './RedemptionForm.css';

const RedemptionForm = () => {
  const parentWindow = "badger.stran.store";
  const rules = window.rules;

  const isValidOrigin = parentWindow && rules && rules[parentWindow];

  const [countryList, setCountryList] = useState([]);
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [couponValid, setCouponValid] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [quoteId, setQuoteId] = useState(null);
  const [productData, setProductData] = useState({});
  const [loading, setLoading] = useState(false);

  const [address, setAddress] = useState({
    company: parentWindow?.split('.')[0] || '',
    telephone: '',
    postcode: '',
    city: '',
    firstname: '',
    lastname: '',
    email: '',
    region: '',
    street: ['', ''],
    street1: '',
    street2: '',
    region_id: 0,
    region_code: '',
    country_id: '',
    shipping_method_code: 'flatrate',
    shipping_carrier_code: 'flatrate',
  });

  useEffect(() => {
    const loadCountries = async () => {
      const countries = await fetchCountries();
      setCountryList(countries);
    };
    loadCountries();
  }, []);

  const selectedCountry =
    countryList.find((c) => c.id === address.country_id) ?? null;

  const handleCouponSubmit = async (e) => {
    e.preventDefault();

    if (!code.trim()) {
      setError('Please enter a coupon code.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await fetch(`https://ofm.stran.store/api/magento/badger-vet/coupon/${code}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ parentWindow, rules }),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();

      if (data.error) {
        setError(data.error);
      } else {
        setQuoteId(data.data.quoteId);
        setProductData(data.data.productData);
        setCouponValid(true);
      }
    } catch (err) {
      console.error(err);
      setError('Coupon not found or API error');
    } finally {
      setLoading(false);
    }
  };

  const handleAddressSubmit = async (e) => {
    e.preventDefault();

    if (!quoteId) {
      alert('Missing quote ID');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await fetch('https://ofm.stran.store/api/magento/badger-vet/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          quoteId,
          ...address,
          street: [address.street1, address.street2].filter(
            (s) => s.trim() !== ''
          ),
        }),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setSubmitted(true);
    } catch (err) {
      console.error('Failed to submit address', err);
    } finally {
      setLoading(false);
    }
  };

  if (!isValidOrigin) {
    return <h3>Something went wrong. Invalid or missing origin.</h3>;
  }

  return (
    <>
      {!couponValid && (
        <CouponForm
          code={code}
          onChange={(e) => setCode(e.target.value)}
          onSubmit={handleCouponSubmit}
          error={error}
          loading={loading}
        />
      )}

      {submitted && (
        <div className="popup">
          <div>
            <p>Your order has been received and will be processed within 2-3 business days.</p>
            {/* <button
              className="form-button"
              onClick={() => {
                window.parent.location.href = '/';
              }}
            >
              Continue Shopping
            </button> */}
          </div>
        </div>
      )}

      {couponValid && !submitted && (
        <div className="form-layout">
          {productData.shortDescription && (
            <div className="product-preview">
              <img src={productData.fullImageUrl} alt="Product" />
              <p
                dangerouslySetInnerHTML={{
                  __html: productData.shortDescription,
                }}
              />
            </div>
          )}

          <CheckoutForm
            address={address}
            onChange={(e) => {
              const { name, value } = e.target;

              setAddress((prev) => {
                const updated = {
                  ...prev,
                  [name]: name === 'region_id' ? parseInt(value) : value,
                };

                updated.street = [updated.street1, updated.street2];

                if (name === 'region_code' && selectedCountry?.available_regions) {
                  const selectedRegion =
                    selectedCountry.available_regions.find(
                      (r) => r.code === value
                    );

                  updated.region_id = selectedRegion
                    ? parseInt(selectedRegion.id)
                    : 0;
                  updated.region = selectedRegion ? selectedRegion.name : '';
                }

                return updated;
              });
            }}
            onSubmit={handleAddressSubmit}
            error={error}
            loading={loading}
            countryData={selectedCountry}
          />
        </div>
      )}
    </>
  );
};

export default RedemptionForm;
